<template>
 <div class="row mt-4 mb-2 font-weight-bold" style="font-size: 16px; text-decoration: underline;"> {{ $t('demand.tabs.summary.tradeIn.label') }}</div>
     <div v-for="orderItem in orderItems" :key="orderItem.resourceUid">
        <div class="row">
            <div class="col-7">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
               {{ $t('demand.tabs.summary.vehicle.brand') }}
              </label>
              <span class="font-weight margin-left color" >
                {{getAssets(orderItem).brand}}
              </span>
            </div>
            <div class="col-2">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                {{ $t('demand.tabs.summary.tradeIn.currentMileage') }}
                
              </label>
              <span class="font-weight margin-left color" >
                {{getAssets(orderItem).currentMileage}}
              </span>
            </div>
            <div class="col-3">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                 {{ $t('demand.tabs.summary.tradeIn.firstMatriculation') }}
                
              </label>
              <span class="font-weight margin-left color" >
                 {{getAssets(orderItem).matriculationDate}}
              </span>
            </div>
        </div>   
        <div class="row">
            <div class="col-3">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                {{ $t('demand.tabs.summary.tradeIn.owner') }}
                
              </label>
              <span class="font-weight margin-left color" >
              {{getClientName(orderItem)}}
              </span>
            </div>
            <div class="col-4">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                {{ $t('demand.tabs.summary.vehicle.chassis') }}
              </label>
              <span class="font-weight margin-left color" >
                 {{getAssets(orderItem).chassisReference}}
              </span>
            </div>
            <div class="col-2">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                {{ $t('demand.tabs.summary.vehicle.energie') }}
              </label>
              <span class="font-weight margin-left color" >
                 {{getAssets(orderItem).engineType}}
              </span>
            </div>
            <div class="col-3">
              <label
                class="d-block font-semi-bold mb-0 font-size color font-weight">
                  {{ $t('demand.tabs.summary.vehicle.matriculation') }}
              </label>
              <span class="font-weight margin-left color" >
                   {{getAssets(orderItem).matriculation}}
              </span>
            </div>
        </div>    
     </div>   
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";


@Options({
  props: ["orderItems","orderClient"],
  components: {
  },
})
export default class summaryTabOrderTradeIn extends Vue {
   orderItems?: Array<any>;
   orderClient?: any;
    getAssets(orderItem: any) {
    let assetInfo = {}
    const asset = orderItem && orderItem.orderAssets && orderItem.orderAssets.length
            ? orderItem.orderAssets.filter((asset:any)=> asset.assetTradeIn && (asset.assetTradeIn.origin ==="" || asset.assetTradeIn.origin !=="") )[0]
            : null;
    const brand = asset.brand ? asset.brand.replace(/asset.good.vehicle.brand./g, "")   : "-"
    const range = asset.range && asset.range?.includes('range.') ? asset.range.substring(asset.range.lastIndexOf(".") + 1) : asset.range ? asset.range : "-" ;
    const version = asset.version && asset.version?.includes('range.') ? asset.version.substring(asset.version.lastIndexOf("range") + 6) : asset.version ? asset.version  : "-" ;
    const color = asset.color ? asset.color : "-"
    const chassisReference = asset.chassisReference ? asset.chassisReference : "-"
    const engineType = asset.engineType ? asset.engineType.replace(/asset.good.vehicle.energytype./g, "")  : "-"
    const matriculation = asset.matriculation ? asset.matriculation : "-"   
    const matriculationDate = asset.matriculationDate ? asset.matriculationDate : "-"   
    const currentMileage = asset.currentMileage ? asset.currentMileage : "-"
    assetInfo = {
      "brand": brand+" "+range+" "+version,
       "color":color,
        "chassisReference": chassisReference,
        "engineType": engineType,
        "matriculation": matriculation,
        "matriculationDate": matriculationDate,
        "currentMileage": currentMileage
      }
   return assetInfo 
  }  
   get client (){
      return this.orderClient  && this.orderClient.orderParty && this.orderClient.orderParty.party && this.orderClient.orderParty.party.rawData && this.orderClient.orderParty.party.rawData.responseData
                   ? this.orderClient.orderParty.party.rawData.responseData
                   : null
   }
   getClientName(orderItem: any) {
    const asset = orderItem && orderItem.orderAssets && orderItem.orderAssets.length
            ? orderItem.orderAssets.filter((asset:any)=> asset.assetTradeIn && (asset.assetTradeIn.origin ==="" || asset.assetTradeIn.origin !=="") )[0]
            : null;
    const  clientType  = this.orderClient  && this.orderClient.orderParty && this.orderClient.orderParty.party && this.orderClient.orderParty.party.objectType
                   ? this.orderClient.orderParty.party.objectType
                   : "-"
    return asset && asset.resourceUid && clientType === "odm.party.party.person.frenchperson" 
            ? `${this.client.firstName} ${this.client.familyName}`
            : asset && asset.resourceUid && clientType === "odm.party.party.organization.frenchorganization"
            ?  `${this.client.name}`
            : "-"
  }
}
</script>

<style scoped>
</style>
